import e from "jquery";
import "select2/dist/js/select2.full";
import "select2/dist/css/select2.min.css";

function t(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function n(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function r(e) {
  for (var r = 1; r < arguments.length; r++) {
    var o = null != arguments[r] ? arguments[r] : {};
    r % 2 ? n(Object(o), !0).forEach(function (n) {
      t(e, n, o[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : n(Object(o)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }

  return e;
}

function o(e) {
  return function (e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = new Array(e.length); t < e.length; t++) {
        n[t] = e[t];
      }

      return n;
    }
  }(e) || function (e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

var i = function (e, t, n, r, o, i, s, l, c, a) {
  "boolean" != typeof s && (c = l, l = s, s = !1);
  var u = "function" == typeof n ? n.options : n;
  var d;
  if (e && e.render && (u.render = e.render, u.staticRenderFns = e.staticRenderFns, u._compiled = !0, o && (u.functional = !0)), r && (u._scopeId = r), i ? (d = function d(e) {
    (e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), t && t.call(this, c(e)), e && e._registeredComponents && e._registeredComponents.add(i);
  }, u._ssrRegister = d) : t && (d = s ? function (e) {
    t.call(this, a(e, this.$root.$options.shadowRoot));
  } : function (e) {
    t.call(this, l(e));
  }), d) if (u.functional) {
    var _e = u.render;

    u.render = function (t, n) {
      return d.call(n), _e(t, n);
    };
  } else {
    var _e2 = u.beforeCreate;
    u.beforeCreate = _e2 ? [].concat(_e2, d) : [d];
  }
  return n;
}({
  render: function render() {
    var e = this.$createElement,
        t = this._self._c || e;
    return t("div", [t("select", {
      staticClass: "form-control",
      attrs: {
        id: this.id,
        name: this.name,
        disabled: this.disabled,
        required: this.required
      }
    })]);
  },
  staticRenderFns: []
}, void 0, {
  name: "Select2",
  data: function data() {
    return {
      select2: null
    };
  },
  model: {
    event: "change",
    prop: "value"
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    settings: {
      type: Object,
      default: function _default() {}
    },
    value: null
  },
  watch: {
    options: function options(e) {
      this.setOption(e);
    },
    value: function value(e) {
      this.setValue(e);
    }
  },
  methods: {
    setOption: function setOption() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      this.select2.empty(), this.select2.select2(r({
        placeholder: this.placeholder
      }, this.settings, {
        data: e
      })), this.setValue(this.value);
    },
    setValue: function setValue(e) {
      e instanceof Array ? this.select2.val(o(e)) : this.select2.val([e]), this.select2.trigger("change");
    }
  },
  mounted: function mounted() {
    var t = this;
    this.select2 = e(this.$el).find("select").select2(r({
      placeholder: this.placeholder
    }, this.settings, {
      data: this.options
    })).on("select2:select select2:unselect", function (e) {
      t.$emit("change", t.select2.val()), t.$emit("select", e.params.data);
    }), this.setValue(this.value);
  },
  beforeDestroy: function beforeDestroy() {
    this.select2.select2("destroy");
  }
}, void 0, !1, void 0, !1, void 0, void 0, void 0);

function s(e) {
  s.installed || (s.installed = !0, e.component("MyComponent", i));
}

var l = {
  install: s
},
    c = null;
"undefined" != typeof window ? c = window.Vue : "undefined" != typeof global && (c = global.Vue), c && c.use(l);
export default i;
export { s as install };